import { FC } from 'react';

import { ImageData } from '../VariationOne';
import {
  SettingsModal as SharedSettingsModal,
  WATERMARK_SECTIONS,
  withWatermarkDefaults,
} from '../shared';

export const TEXT_POSITIONS = ['bottom', 'top'];
const DIVIDERS = ['none', 'white', 'black'];
export const ACTUAL_PHOTO_VALUES = ['none', 'bottom', 'top'];

interface Props {
  image: ImageData;
  imageIndex: number;
  type: 'left' | 'right';
  onClose: () => void;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
}

/**
 * Settings Modal for VariationTwoImagesTwoTexts
 * Wraps the shared SettingsModal with variation-specific configuration
 *
 * Before refactoring: 197 lines
 * After refactoring: ~65 lines (67% reduction)
 */
const SettingsModal: FC<Props> = ({ type, image, ...props }) => {
  const typeLabel = type === 'left' ? 'Left' : 'Right';

  return (
    <SharedSettingsModal
      {...props}
      image={withWatermarkDefaults(image)}
      title={`${typeLabel} Image Parameters`}
      sections={[
        ...WATERMARK_SECTIONS,
        {
          title: `${typeLabel} Text Position`,
          type: 'radio',
          stateKey: 'textPosition',
          options: TEXT_POSITIONS,
        },
        {
          title: `Other ${typeLabel} Text Parameters`,
          type: 'checkbox',
          stateKey: '',
          checkboxes: [
            { key: 'quotes', label: 'Quotes' },
            { key: 'brakes', label: 'Custom brakes' },
          ],
        },
        {
          title: 'Cover Divider',
          type: 'radio',
          stateKey: 'divider',
          options: DIVIDERS,
          show: type === 'left',
        },
      ]}
    />
  );
};

export default SettingsModal;
